module.exports = __webpack_public_path__ + "static/img/CT_4.cc6c1307.png";